import {
    redirect,
    Form,
} from 'react-router-dom';
import {
    QueryClient,
} from 'react-query';

import {
    createWordType
} from 'api/language/language';
import { WordTypeRequest } from 'api/models';

export const action = (queryClient: QueryClient) =>
    async ({ params, request }: any) => {
        const formData = await request.formData();
        const updates = Object.fromEntries(formData);
        await createWordType(params.id, updates as WordTypeRequest);
        return redirect('../');
    };

function WordTypeCreator() {

    return (
        <div>
            <Form
                className="flex flex-col max-w-md mx-auto"
                method="post"
                id="new-word-type"
            >
                <label
                    className="mt-8 text-gray-500"
                    htmlFor="name"
                >
                    Name:
                    <input
                        autoFocus
                        placeholder="Word Type"
                        aria-label="Name"
                        type="text"
                        name="name"
                        className="w-full px-4 py-2 mt-2 mb-4 text-lg font-semibold border-2 border-gray-400 rounded-md"
                    />
                </label>
                <button
                    className="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-orange-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    type="submit"
                >Save</button>
            </Form>
        </div>
    );
}

export default WordTypeCreator;